// Some LaunchDarkly flags are warehouse-array flags: the variation value is the
// list of warehouse ids the feature is enabled for ('*' = all), not a boolean.
// An empty array is truthy, so testing one of these flags directly turns the
// feature on everywhere — route it through here instead.
export const isWarehouseFlagEnabled = (
  flag: unknown,
  selectedWarehouseId: string | undefined,
): boolean => {
  if (!Array.isArray(flag) || !selectedWarehouseId) return false;
  return flag.includes('*') || flag.includes(selectedWarehouseId);
};
